import React from 'react';

const CampaignTypePage = React.lazy(() => import('pages/CampaignType/CampaignTypePage'));
const CampaignTypeAddPage = React.lazy(() => import('pages/CampaignType/CampaignTypeAddPage'));

const CampaignType= [
  {
    path: '/campaign-type',
    exact: true,
    name: 'Danh sách loại chiến dịch',
    function: 'CRM_CAMPAIGNTYPE_VIEW',
    component: CampaignTypePage,
  },
  {
    path: '/campaign-type/add',
    exact: true,
    function: 'CRM_CAMPAIGNTYPE_ADD',
    name: 'Thêm mới loại chiến dịch',
    component: CampaignTypeAddPage,
  },
  {
    path: '/campaign-type/detail/:id',
    exact: true,
    function: 'CRM_CAMPAIGNTYPE_DETAIL',
    name: 'Chi tiết loại chiến dịch',
    component: CampaignTypeAddPage,
  },
  {
    path: '/campaign-type/edit/:id',
    exact: true,
    function: 'CRM_CAMPAIGNTYPE_EDIT',
    name: 'Chỉnh sửa loại chiến dịch',
    component: CampaignTypeAddPage,
  },
];

export default CampaignType;
